import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { RefreshTokenAction } from '@tsin-core/actions/auth.action';
import { AuthState } from '@tsin-core/states/auth.state';
import { catchError, switchMap, throwError } from 'rxjs';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  // const store: Store = inject(Store);
  // const token = store.selectSnapshot<string | null>(AuthState.getToken);

  // if (token && token.length > 0) {
  //   // console.info('Token is here', token);
  //   req = req.clone({
  //     setHeaders: {
  //       Authorization: `Bearer ${token}`
  //     }
  //   });
  // }

  // return next(req);

  const store: Store = inject(Store);
  const token = store.selectSnapshot<string | null>(AuthState.getToken);
  const refreshToken = store.selectSnapshot<string | null>(AuthState.getRefreshToken);

  if (token && token.length > 0) {
    if (!req.url.includes('/api/auth/refresh')) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
  }

  return next(req).pipe(
    catchError((error: any) => {
      console.log('Error occurred:', error);
      if (error.status === 401 &&
        error.error &&
        error.error.name === 'TokenExpiredError' &&
        refreshToken &&
        !req.url.includes('/api/auth/refresh')) {
        // Return the observable from the dispatch operation
        return store.dispatch(new RefreshTokenAction({ refreshToken })).pipe(
          catchError(() => throwError(() => error)), // If refresh fails, propagate original error
          switchMap((response: any) => {
            const newToken = response.token;
            if (newToken) {
              const clonedReq = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${newToken}`
                }
              });
              // retry the failed request with the refreshed token
              return next(clonedReq);
            }
            return throwError(() => error);
          })
        );
      }

      // For other errors, just propagate
      return throwError(() => error);
    })
  );

};
